import { z } from "zod";

import i18next from "../../../../../../../i18n";

export const bankDetailsSchema = () => {
    const bankNameError: string = i18next.t("errorMessages:bankDetailsForm.bankNameError");
    const swiftBicCodeError: string = i18next.t("errorMessages:bankDetailsForm.swiftBicCodeError");
    const currencyError: string = i18next.t("errorMessages:bankDetailsForm.currencyError");
    const accountNumberError: string = i18next.t("errorMessages:bankDetailsForm.accountNumberError");
    const accountHolderError: string = i18next.t("errorMessages:bankDetailsForm.accountHolderError");
    return z.object({
        bankName: z.string().min(1, bankNameError),
        swiftBicCode: z.string().min(1, swiftBicCodeError),
        currency: z.string().min(1, currencyError),
        accountNumber: z.string().min(1, accountNumberError),
        accountHolder: z.string().min(1, accountHolderError),
        correspondingBank: z.string().optional(),
        branchNumber: z.string().optional()
    });
};
